import { BaseRequest } from './BaseRequest';

export class ContextRequest extends BaseRequest {
    ContactIdentity : string | null;
    ContextKey : string | null;
    ContextValue : string | null;
    
    constructor(contactIdentity: string, contextKey: string, contextValue: string, clusterName: string, botIdentifier: string) {
      super();
      this.ContextKey = contextKey;
      this.ContextValue = contextValue;
      this.ClusterName = clusterName;
      this.BotIdentifier = botIdentifier;
      this.ContactIdentity = contactIdentity;
    }
}